import React from "react";
import { T } from "../app/tokens.js";

export function IdentityMatchHint({ value, inline = false }) {
  if (!value) return null;
  return (
    <span data-testid="identity-match-hint" title={`matched: ${value}`}
      style={{ display: inline ? "inline-block" : "block", minWidth: 0, ...(inline ? { marginLeft: 6, flex: "0 1 auto" } : {}), maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis",
        whiteSpace: "nowrap", color: T.mid, fontSize: T.fsXxxs5, lineHeight: "14px", fontWeight: T.fwNormal }}>
      matched: {value}
    </span>
  );
}
